module.exports = __webpack_public_path__ + "img/IMG_9928_L_BlackMatted_MockedUp.e8f06ac2.jpg";